import * as Yup from 'yup';

export const getSetNewPasswordSchema = () => {
  return Yup.object().shape({
    password: Yup.string()
      .min(6, 'Password must be at least 6 characters')
      .matches(
        /^(?=.*[\d!@#$%^&*(),.?":{}|<>]).{6,}$/,
        'Contain at least one number or one special character.',
      )
      .required('Password is required'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'Passwords must match')
      .min(6, 'Password must be at least 6 characters')
      .matches(
        /^(?=.*[\d!@#$%^&*(),.?":{}|<>]).{6,}$/,
        'Contain at least one number or one special character.',
      )
      .required('Confirm Password is required'),
  });
};
